import { textStyles, colors, loadingDark, loadingLight } from '../../shared/styles';

export const styles = {
  container: {
  	marginBottom: 35
  },
  eventContainer: {
    position: 'relative',
    marginBottom: 35,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  eventTitle: {
  	marginBottom: 13,
  	...textStyles.sectionHead,
  },
  siteLink: {
    display: 'block',
    fontSize: 14,
    color: colors.blue,
  },
  link: {
  	display: 'block',
  	marginBottom: 7,
    fontSize: 14,
    color: colors.blue,
  },

  loadingContainer: (show) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    pointerEvents: 'none',
    opacity: (show) ? 1 : 0,
    transition: 'opacity 0.3s',
  }),
  loadingTitle: {
    width: '50%',
    height: 12,
    marginBottom: 12,
    pointerEvents: 'none',
    ...loadingDark,
  },
  loadingDetail: {
    width: '100%',
    height: 15,
    pointerEvents: 'none',
    ...loadingLight,
  },
};
